import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tag} from "../../Progetti/Models/tag";
import {ClassicType} from "../../shared/models/ClassicType";

@Component({
  selector: 'app-scheda-tecnica-prodotto',
  templateUrl: './scheda-tecnica-prodotto.component.html'
})
export class SchedaTecnicaProdottoComponent implements OnInit {
  @Input() items: Tag[] ;
  @Output() itemsChange = new EventEmitter<Tag[]>();
  constructor() { }

  ngOnInit(): void {
  }

  delete(item: Tag,data: ClassicType) {
    const idx: number = item.tags.findIndex(x => x == data);
    if (idx > -1) {
      item.tags.splice(idx, 1);
      this.itemsChange.emit(this.items);
    }
  }

  add() {
    this.items = this.items && this.items?.length>0 ? this.items : [];
    this.items.push({cat:"",tags: []});
  }

  addTag(item: Tag) {
    item.tags = item?.tags && item.tags.length > 0 ? item.tags : [];
    item.tags.push({label: "", value: "", id: undefined})
  }
  ItemsChanged(){
    this.itemsChange.emit(this.items);
  }
}
